









































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import formatScore from '../../utils/format-score';
import Logo from './Logo.vue';

@Component({
  components: {
    Logo,
  },
})
class YearShare extends Vue {
  @Prop({}) data: any;

  get username() {
    return this.data.username || this.data.user_name;
  }

  get languages() {
    return (this.data.top_languages.top_5 || []).slice(0, 3).map((l: any) => l.language);
  }

  get repos() {
    return (this.data.repo_score_gain || []).slice(0, 3).map((r: any) => r.repo_name);
  }

  get commits() {
    return this.formatThousands(this.data.total_commits.commit_count);
  }

  get insertions() {
    return this.formatThousands(this.data.total_commits.insertions);
  }

  get deletions() {
    return this.formatThousands(this.data.total_commits.deletions);
  }

  formatThousands(number: number): number | string {
    if (number > 9999) {
      return `${this.formatNumber(Math.round(number / 1000))}K`;
    }
    return this.formatNumber(number);
  }

  formatNumber(number: number) {
    return formatScore(number);
  }
}
export default YearShare;
